module.exports = __webpack_public_path__ + "static/media/Background_Camp_1080.b34e3567.png";